import { useState, useEffect, useContext } from "react";
import NotyfContext from "../../../../../../contexts/NotyfContext";
import api from "../../../../../../service/api";
// import api from "../../../../service/api";
// import NotyfContext from "../../../../contexts/NotyfContext";

export default function useSignatureSubmit({ id }) {
    const notyf = useContext(NotyfContext);
    const [payLoad, setPayload] = useState(null);
    const [loadSignatures, setLoadSignatures] = useState(false);
    const [requestRefresh, setRequestRefresh] = useState(false);

    const payloadHandlers = {
        draw: (signature) => {
            const drawing = new FormData();
            drawing.append("data", signature.data);
            return drawing;
        },
        upload: (signature) => {
            const fd = new FormData();
            signature.files.forEach((fileItem, index) => {
                fd.append(`files[${index}]`, fileItem.file);
            });
            return fd;
        },
        selection: (signature) => {
            const selectedSignature = new FormData();
            selectedSignature.append('signature_id', signature.id);
            return selectedSignature;
        }
        // add more types here in the future
    };

    // Helper to decide request payload
    const buildRequestData = (signature) => {
        const handler = payloadHandlers[signature.type];
        if (!handler) {
            console.warn(`No handler defined for type "${signature.type}"`);
            return null;
        }

        const result = handler(signature);
        // Wrap draw or other JSON payload in FormData if necessary
        if (result instanceof FormData) {
            result.append("id", id);
            result.append("date", new Date() .toISOString());
            result.append("type", signature.type);
            result.append("batch_student_id", signature.additionalPayloadData.batch_student_id);
            result.append("template_id", signature.additionalPayloadData.template_id);
        } else {
            return {
                ...result,
                id: id,
                date: signature.date,
                type: signature.type,
                batch_student_id:  signature.additionalPayloadData.batch_student_id,
                template_id:  signature.additionalPayloadData.template_id,
            };
        }
        return result;
    };

    const handleSubmit = async (signature) => {
        const data = buildRequestData(signature);
        if (!data) return;
        setLoadSignatures(true);

        try {
            const config =
                data instanceof FormData
                    ? { headers: { "Content-Type": "multipart/form-data" } }
                    : {};

            const response = await api.post(
                "tms/bca-forms/save-signature", // TODO change this link
                data,
                config
            );

            console.log("Signature saved bca forms:", response);
            notyf?.success("Signature saved successfully!");
        } catch (error) {
            const message =
                error.response?.data?.message ||
                error.message ||
                "Error saving signature";
            console.error("Error saving signature:", message);
            notyf?.error("Error saving signature:\n" + message);
        }
        finally{
            setLoadSignatures(false);
            setRequestRefresh(true);
        }
    };

    return { 
        handleSubmit, 
        loadSignatures,
        requestRefresh,
        setRequestRefresh,
    };

}
